exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".datafeedLoadingIndicator[data-v-0ed33010]{height:384px;justify-content:center;align-items:center;position:absolute}.pageTitle[data-v-0ed33010]{position:absolute;left:15px}.configureActions[data-v-0ed33010]{position:relative}.modalScrollArea.isMobileSized[data-v-0ed33010]{max-height:400px;overflow-y:scroll}", ""]);

// exports
